export const ROUTES = {
  GENERAL: '/',
  SIGN_IN: '/sign-in',
  LOG_OUT: '/logout',
  FORBIDDEN: '/forbidden',

  TRAILED_DIRECT_GROUPS: '/trailed-direct-groups/:group/:status',
  TRAILED_DIRECT_GROUPS_DETAIL:
    '/trailed-direct-groups/:group/:status/:type/:id',
  TRAILED_DIRECT_GROUPS_DETAIL_SCHEDULE:
    '/trailed-direct-groups/:group/:status/:type/:id/schedules',
  TRAILED_DIRECT_GROUPS_DETAIL_SCHEME:
    '/trailed-direct-groups/:group/:status/:type/:id/scheme',
  TRAILED_DIRECT_GROUPS_DETAIL_WAGON_GROUPS:
    '/trailed-direct-groups/:group/:status/:type/:id/wagon-groups',

  CARRIAGE_GROUPS: '/wagon-groups/:group/:status',
  CARRIAGE_GROUP_CREATE: '/wagon-groups/:group/:status/create',
  CARRIAGE_GROUP_EDIT: '/wagon-groups/:group/:status/:type/:id/edit',
  CARRIAGE_GROUP_CHART: '/wagon-groups/:group/:status/:type/:id/chart',
  CARRIAGE_GROUP_CARRIAGES_BY_DATE:
    '/wagon-groups/:group/:status/:type/:id/carriages-by-date',

  DICTIONARIES: '/dictionaries',
  // ------------------[ Сеть/Поезда ] --------------------------------------
  DICTIONARIES_MESH_TRAINS: '/dictionaries/mesh-trains',
  DICTIONARY_GDP: '/dictionaries/mesh-trains/gdp',
  DICTIONARY_RAILWAY_ADMINISTRATION:
    '/dictionaries/mesh-trains/railway-administration',
  DICTIONARY_RAILWAYS: '/dictionaries/mesh-trains/railways',
  DICTIONARY_STATIONS: '/dictionaries/mesh-trains/stations',
  DICTIONARY_STATIONS_HISTORY: '/dictionaries/mesh-trains/stations/:id/history',
  DICTIONARY_PASSENGER_CARRIERS_RUSSIAN_RAILWAY:
    '/dictionaries/mesh-trains/passenger-carriers-russian-railway',
  DICTIONARY_BRANCHES: '/dictionaries/mesh-trains/branches',
  DICTIONARY_STRUCTURAL_SUBDIVISIONS:
    '/dictionaries/mesh-trains/structural-subdivisions',
  TRAIN_CATEGORY: '/dictionaries/mesh-trains/train-category',
  TRAIN_SUB_CATEGORIES_DETAILS_SPEED:
    '/dictionaries/mesh-trains/train-sub-category-details-speed',
  DICTIONARY_TRAIN_BRAND: '/dictionaries/mesh-trains/train-brands',
  DICTIONARY_PERIODICITY_SEASON: '/dictionaries/mesh-trains/periodicity-season',
  DICTIONARY_MAX_TRAIN_SPEED: '/dictionaries/mesh-trains/max-train-speed',
  DICTIONARY_TRANSPORTATION_PERFORMANCE_INDICATORS:
    '/dictionaries/mesh-trains/transportation-performance-indicators',
  // ------------------------------------------------------------------------

  // ---------------------[ Вагоны ] ----------------------------------------
  DICTIONARIES_CARRIAGE_GROUPS: '/dictionaries/carriage-groups',
  CARRIAGE_TYPES_SCHEMA: '/dictionaries/carriage-groups/carriage-types-schema',
  CARRIAGE_TYPES: '/dictionaries/carriage-groups/carriage-types',
  CARRIAGE_TYPES_ASU: '/dictionaries/carriage-groups/carriage-types-asu',
  CARRIAGE_TYPES_CSU: '/dictionaries/carriage-groups/carriage-types-csu',
  CARRIAGE_TYPE_ASU_DIMENSION_SEATS_COUNT:
    '/dictionaries/carriage-groups/carriage-type-asu-dimension-seats-count',
  NON_PASSENGER_CARRIAGE_TYPES:
    '/dictionaries/carriage-groups/non-passenger-carriage-types',
  CARRIAGE_DIMENSIONS: '/dictionaries/carriage-groups/carriage-dimensions',
  CARRIAGE_MODELS: '/dictionaries/carriage-groups/carriage-models',
  CARRIAGE_BRAKE_TYPES: '/dictionaries/carriage-groups/carriage-break-types',
  CARRIAGE_HEAT_TYPES: '/dictionaries/carriage-groups/carriage-heat-types',
  CARRIAGE_LENGTH: '/dictionaries/carriage-groups/carriage-length',
  CARRIAGE_SERVICE_CLASSES:
    '/dictionaries/carriage-groups/carriage-service-classes',
  CARRIAGE_SEATS_ALLOCATIONS:
    '/dictionaries/carriage-groups/carriage-seats-allocations',
  CARRIAGE_ADDITIONAL_SEATS_SIGNS:
    '/dictionaries/carriage-groups/carriage-additional-seats-signs',
  // ------------------------------------------------------------------------

  // ---------------------[ Лок. обслуживание ] -----------------------------
  DICTIONARIES_LOCOMOTIVE_SERVICE: '/dictionaries/locomotive-services',
  DICTIONARY_TRACTION_DIRECTORATE:
    '/dictionaries/locomotive-services/traction-directorate',
  DICTIONARY_LOCOMOTIVE_TRACTION_TYPE:
    '/dictionaries/locomotive-services/locomotive-traction-type',
  DICTIONARY_LOCOMOTIVE_SERIES:
    '/dictionaries/locomotive-services/locomotive-series',
  DICTIONARY_LOCOMOTIVE_SERIES_TYPE:
    '/dictionaries/locomotive-services/locomotive-series-type',
  DICTIONARY_LOCOMOTIVE_TYPE_CURRENT:
    '/dictionaries/locomotive-services/locomotive-type-current',
  DICTIONARY_LOCOMOTIVE_TEAM_PRICE_RENT:
    '/dictionaries/locomotive-services/locomotive-team-price-rent',
  DICTIONARY_LOCOMOTIVE_PRICE_TECHNICAL_SERVICE_TABLE:
    '/dictionaries/locomotive-services/locomotive-price-technical-service',
  DICTIONARY_LOCOMOTIVE_SERVICE_EMPIRICAL_PARAMETER:
    '/dictionaries/locomotive-services/locomotive-service-empirical-parameter',
  // ------------------------------------------------------------------------

  // ---------------------[ Инфраструктура ] --------------------------------
  DICTIONARIES_INFRASTRUCTURE: '/dictionaries/infrastructure',
  DICTIONARY_INFRASTRUCTURE_COEFFICIENT_INDEXING:
    '/dictionaries/infrastructure/infrastructure-coefficient-indexing',
  DICTIONARY_INFRASTRUCTURE_APPLICATION_23:
    '/dictionaries/infrastructure/infrastructure-application-23',
  DICTIONARY_INFRASTRUCTURE_APPLICATION_24:
    '/dictionaries/infrastructure/infrastructure-application-24',
  DICTIONARY_INFRASTRUCTURE_APPLICATION_25:
    '/dictionaries/infrastructure/infrastructure-application-25',
  DICTIONARY_INFRASTRUCTURE_APPLICATION_26:
    '/dictionaries/infrastructure/infrastructure-application-26',
  DICTIONARY_INFRASTRUCTURE_APPLICATION_27:
    '/dictionaries/infrastructure/infrastructure-application-27',
  // ------------------------------------------------------------------------

  // ---------------------[ МВПС ] ------------------------------------------
  DICTIONARIES_MVPS: '/dictionaries/mvps',
  DICTIONARY_MVPS_COMPANY_AFFILIATION:
    '/dictionaries/mvps/mvps-company-affiliations',
  DICTIONARY_MVPS_MARTIN_SECTION_TYPE:
    '/dictionaries/mvps/mvps-martin-section-types',
  DICTIONARY_MVPS_MARTIN_SECTION_TYPE_EQUIPMENT:
    '/dictionaries/mvps/mvps-martin-section-type-equipments',
  DICTIONARY_MVPS_RATE_MANAGEMENT_EXPLOITATION_MAINTENANCE_REPAIR:
    '/dictionaries/mvps/mvps-rate-management-exploitation-maintenance-repair',
  // ------------------------------------------------------------------------

  // ---------------------[ Контроль парам. перевозок ] ---------------------
  DICTIONARIES_CONTROL_TRANSPORTATION_PARAMETERS:
    '/dictionaries/control-transportation-parameters',
  DICTIONARY_CONTROL_TRANSPORTATION_PARAMETERS_ROUTES:
    '/dictionaries/control-transportation-parameters/routes',
  // ------------------------------------------------------------------------

  // ---------------------[ Справочники ] -----------------------------------
  MNEMONIC: '/dictionaries/mnemonic',
  // ------------------------------------------------------------------------

  SUMMARY_CALCULATIONS: '/summary-calculations',
  SUMMARY_CALCULATIONS_TRAIN: '/summary-calculations/train',
  SUMMARY_CALCULATIONS_LOCOMOTIVE: '/summary-calculations/locomotive',
  SUMMARY_CALCULATIONS_MVPS: '/summary-calculations/mvps',
  SUMMARY_CALCULATIONS_INFRASTRUCTURE: '/summary-calculations/infrastructure',

  TRAINS: '/trains/:group/:status',
  TRAINS_CREATE: '/trains/:group/:status/create',
  TRAINS_DETAIL: '/trains/:group/:status/:id',

  TRAINS_DETAIL_SCHEDULE: '/trains/:group/:status/:id/schedules',
  TRAINS_DETAIL_SCHEME: '/trains/:group/:status/:id/scheme',
  TRAINS_DETAIL_SCHEME_COMPARE: '/trains/:group/:status/:id/scheme/compare',
  TRAINS_DETAIL_WAGON_GROUPS: '/trains/:group/:status/:id/wagon-groups',
  TRAINS_DETAIL_LOCOMOTIVE_AREA: '/trains/:group/:status/:id/locomotive-area',
  TRAINS_DETAIL_TRAIN_INFO: '/trains/:group/:status/:id/train-info',

  HELP: '/help',
  HELP_MANUAL: '/help/manual',
  HELP_FAQ: '/help/faq',
  HELP_EDUCATION: '/help/education',

  ADMIN: '/admin',
  ADMIN_USERS: '/admin/users',
  ADMIN_ROLES: '/admin/roles',
  ADMIN_RULES: '/admin/roles/:id/rules',
  ADMIN_HELP: '/admin/help',
  ADMIN_HELP_MANUAL: '/admin/help/manual',
  ADMIN_HELP_FAQ: '/admin/help/faq',
  ADMIN_HELP_EDUCATION: '/admin/help/education',
  ADMIN_FLAGS: '/admin/flags',
  ADMIN_DIVISION: '/admin/divisions',
  ADMIN_NEWS: '/admin/news',
  ADMIN_JOURNALS: 'admin/journals',
  ADMIN_JOURNALS_ACTION_USERS: '/admin/journals/journalAction',
  ADMIN_SCHEDULER: '/admin/scheduler',

  INDICATORS: '/indicators',
  INDICATORS_WAGON_GROUPS: '/indicators/wagon-groups',
  INDICATORS_LOCOMOTIVE: '/indicators/locomotive',
  INDICATORS_WAGON_GROUP_DETAIL: '/indicators/wagon-groups/:type/:id',
  INDICATORS_MVPS: '/indicators/mvps',
  INDICATORS_INFRASTRUCTURE: '/indicators/infrastructure',
  INDICATORS_TRAIN_LIST: '/indicators/train-list',
  INDICATORS_TRAIN: '/indicators/train-list/:id',
  INDICATORS_TRAIN_WAGON_GROUPS:
    '/indicators/train-list/train-wagon-groups/:id',
  INDICATORS_FINAL_CALCULATION_WAGON_GROUPS:
    '/indicators/wagon-groups/final-calculation/wagon-groups',
  INDICATORS_PARK_CALCULATION: '/indicators/wagon-groups/park-calculation',

  LOCOMOTIVE_AREA: '/locomotive-area/:status',

  CONTROL_TRANSPORT_PARAMETER: '/control-transport-parameter',
  TPC__CONTROL_AVAILABILITY_SEATS:
    '/control-transport-parameter/control-availability-seats',
  CONTROL_TRANSPORT_PARAMETER_SCHEME_CONTROL:
    '/control-transport-parameter/scheme-control',
  CONTROL_TRANSPORT_PARAMETER_SCHEME_CONTROL_TRAIN_NMRVAG:
    '/control-transport-parameter/scheme-control-train-nmrvag',
  CONTROL_TRANSPORT_PARAMETER_SCHEME_CONTROL_CHANGE_CAPACITY:
    '/control-transport-parameter/scheme-control/change-capacity',
  CONTROL_TRANSPORT_PARAMETER_CHANGE_CAPACITY_TRAINS_REPLENISHMENT:
    '/control-transport-parameter/scheme-control/change-capacity/trains-replenishment/:id',
  CONTROL_TRANSPORT_PARAMETER_LOCATION_CARRIAGE_GROUP:
    '/control-transport-parameter/location-carriage-group',

  PROFILE: '/profile',
};
